const pendingKey = "juristai_saml_pending";
export const hasPendingSamlSignIn = () => Boolean(sessionStorage.getItem(pendingKey));
export const markPendingSamlSignIn = () => sessionStorage.setItem(pendingKey, "1");
export const consumeSamlRedirect = () => {
  const params = new URLSearchParams(window.location.search); if (!params.has("code") && !params.has("error")) return null;
  const pending = hasPendingSamlSignIn(); sessionStorage.removeItem(pendingKey);
  if (!pending) throw new Error("SAML sign-in state is invalid.");
  if (params.has("error")) throw new Error("Firm SSO sign-in was not completed.");
  return { code: params.get("code"), state: params.get("state") };
};
